<template>
  <div class="footer-text">
    <a class="singenuity" href="https://singenuity.com/" target="_blank">
      <img src="@/assets/logo.png" height="32" />
      Powered by Singenuity
    </a>
    <div class="square">
      <span>Secure payments with</span>
      <img src="@/assets/Square-Logo.png" height="32" />
    </div>
  </div>
</template>

<script>
export default {
  name: "PoweredBy.vue",
};
</script>

<style lang="scss" scoped>
$cart-width: 942px;

.footer-text {
  background: #f8f8f8;
  display: flex;
  justify-content: space-between;
  width: $cart-width;
  margin: auto;
  padding: 40px 0;
  font-size: 14px;

  // mobile
  @media only screen and (max-width: $cart-width) {
    width: 100vw;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}

.singenuity {
  display: flex;
  align-items: center;

  &:hover {
    color: #0099ff;
  }
}

.square {
  display: flex;
  align-items: center;

  span::after {
    content: "\00a0";
  }
}
</style>
